export default __webpack_public_path__ + "static/media/git.fa6fcb45.svg";